<template>
    <panel-navigation>
        <call-modal ref="CallModal"></call-modal>
            <div class="float-right pt-3">
                <div class="border-1 border-purple bg-purple text-white text-xs text-bold px-4 py-2 rounded cursor-pointer float-right ml-2"
                     style="margin-top: -5px;" @click="downloadCsv()">

                    <i class="fa fa-spin fa-spinner mr-2" v-if="exporting"></i> Export
                </div>
            </div>

            <div class="rg-top-filter pt-1 float-right mr-2">
                <v-text-field
                    :value="((date_filter == null) ? 'Choose Date' : formatDate(date_filter[0], 'MMM DD, YYYY') + '   -   ' + ((date_filter[1]) ? formatDate(date_filter[1], 'MMM DD, YYYY') : ''))"
                    append-icon="mdi-calendar-blank-outline"
                    readonly
                    outlined
                    dense
                    style="width: 230px; background: #FFFFFF; border: 0px !important;"
                    hide-details
                    placholder="Choose Date"
                    @click="show_picker = !show_picker"
                ></v-text-field>
                
                <div v-if="show_picker" style="position: absolute; z-index: 999;">
                    <v-date-picker
                    v-model="date_filter"
                    range
                    no-title
                    scrollable
                    @input="menu = false"
                    >
                    <v-spacer></v-spacer>
                        <v-btn
                            text
                            color="#44468F"
                            @click="show_picker = false"
                        >
                            Cancel
                        </v-btn>
                        <v-btn
                            text
                            color="#44468F"
                            @click="filterDate();"
                        >
                            OK
                        </v-btn>
                    </v-date-picker>
                </div>
            </div>

            <h1 class="text-lg font-semibold mb-3">Messages
                <v-chip
                        class="ma-2"
                        color="#44468F"
                        outlined
                        small
                >
                    {{ messages.length }}
                </v-chip>
            </h1>
            <hr class="border-b border-gray-100 mb-3">

            <template>
                <v-row class="my-3 rg-top-filter">
                    <v-col cols="12" md="4" sm="4" xs="6">
                        <v-text-field
                                clearable
                                outlined
                                dense
                                hide-details
                                prepend-inner-icon="mdi-magnify"
                                label="Search"
                                v-model="search"

                                class="white border border-white"
                        ></v-text-field>
                    </v-col>
                    <template>
                        <v-col cols="12" md="4" sm="4" xs="6">
                            <v-select
                                    outlined
                                    dense
                                    hide-details
                                    label="Tags"
                                    class="white header-inputs"
                                    :item-text="item => item.text"
                                    :item-value="item => item.index"
                                    :items="tags_items"
                                    v-model="tag"
                                    clearable
                            ></v-select>
                        </v-col>
                        <v-spacer></v-spacer>
                        <v-col cols="12" md="4" sm="4" xs="6">
                            <div class="float-left" style="width: calc(100% - 85px);">
                                <v-select
                                        clearable
                                        outlined
                                        dense
                                        hide-details
                                        label="Status"
                                        :item-text="item => item.text"
                                        :item-value="item => item.index"
                                        class="white header-inputs"
                                        :items="qualify_status_items"
                                        v-model="qualify_status"
                                        clearable
                                ></v-select>
                            </div>

                            <div class="border-1 border-purple bg-purple text-white text-xs text-bold px-4 rounded cursor-pointer float-right ml-2" style="padding-bottom: 11px; padding-top: 11px;"
                                @click="getMessages();"
                            >
                                Filter
                            </div>
                        </v-col>
                    </template>
                </v-row>
            </template>
            <template>
                <div class="dashboard-box">
                    <v-card class="pa-2" tile>
                        <v-skeleton-loader v-if="loading" type="article, article, article"></v-skeleton-loader>

                        <div v-else class="p-3">
                            <div v-if="messages.length == 0">
                                <br/><br/><br/><br/>
                                <div class="dashboard-box-iconsquare">
                                    <div class="dashboard-box-icon-background"></div>
                                    <div class="dashboard-box-icon">
                                        <i class="mdi mdi-phone"></i>
                                    </div>
                                </div>
                                <div style="text-align: center;">
                                    <div class="pt-2 pb-2">
                                        <strong>No Messages</strong>
                                    </div>

                                    <div class="text-sm mb-4 text-gray-600">
                                        No messages found for the given period. Refine your search or wait until new messages come in.
                                    </div>
                                    <br/>
                                </div>
                                <br/><br/><br/><br/><br/>
                            </div>

                            <div v-else style="clear: both; padding-top: 0px;">
                                <v-data-table
                                :headers="headers"
                                :items="messages"
                                :items-per-page="20"
                                class="rg-datatable elevation-1"
                                :footer-props="{
                                itemsPerPageOptions: [10, 20, 30, 40, 50, 100],
                                showFirstLastPage: true
                                }"
                                mobile-breakpoint="10"
                                >
                                    <template v-slot:item.created_at="{ item }">
                                        <router-link :to="'/leads/calls/details/' + item.call_sid">{{ displayTimestamp(item.created_at) }}</router-link>
                                    </template>

                                    <template v-slot:item.job_type="{ item }">
                                        {{ item.job_type.replace(/\_/g, " ").toLowerCase().replace(/\b[a-z]/g, function(letter) { return letter.toUpperCase(); }) }}
                                    </template>

                                    <template v-slot:item.call_status="{ item }">
                                        <span v-if="item.call_status == 'in-progress'">
                                            <i class="fa fa-spin fa-spinner"></i>
                                        </span>
                                        <span v-else>
                                            {{ item.call_status }}
                                        </span>
                                    </template>

                                    <template v-slot:item.from="{ item }">
                                        {{ formatPhoneNumber(item.from) }}
                                    </template>

                                    <template v-slot:item.to="{ item }">
                                        {{ formatPhoneNumber(item.to) }}
                                    </template>

                                    <template v-slot:item.recording_url="{ item }">
                                        <div v-if="item.recording_url">
                                            <i class="audio-element-icon fa fa-play" :id="'audio-element-icon-' + item.id" style="cursor: pointer;" @click="playAudio(item);"></i>

                                            <div class="audio-element-wrapper" :id="'audio-element-wrapper-' + item.id" style="position: absolute; z-index: 99; margin-left: -10px; display: none !important; margin-top: -20px;">
                                                <i class="mdi mdi-close-circle" style="position: absolute; right: 0px; top: -10px; font-size: 20px; z-index: 99; cursor: pointer;" @click="playAudio(item)"></i>
                                                <audio class="audio-element" :id="'audio-element-' + item.id" controls="play, pause, volume" style="height: 38px;">
                                                    <source :src="item.recording_url" type="audio/mpeg">
                                                </audio>
                                            </div>
                                        </div>
                                        <div v-else>
                                            -
                                        </div>
                                    </template>

                                    <template v-slot:item.value="{ item }">
                                        <div :class="'lsa-show-value lsa-show-value-' + item.id">
                                            <a href="javascript: void(0);" @click="showEditValue(item)">${{ item.value }} <i class="mdi mdi-pencil-outline ml-2"></i></a>
                                        </div>
                                        <div :class="'lsa-edit-value lsa-edit-value-' + item.id" style="display: none; position: relative;">
                                            <input type="text" :value="((item.value > 0) ? item.value : me.settings.customer_value)" style="padding: 5px; border: solid 1px #CCCCCC; width: 100px;" />
                                            <div style="position: absolute; margin-top: -22px; right: 9px;">
                                                <a href="javascript: void(0);" style="color: #3EBB80 !important;" @click="editValue(item)"><i class="mdi mdi-check"></i></a>
                                                <a href="javascript: void(0);" class="ml-2" style="color: #E53F71 !important;" @click="cancelEditValue(item)"><i class="mdi mdi-close"></i></a>
                                            </div>
                                            <div style="clear: both;"></div>
                                        </div>
                                    </template>

                                    <template v-slot:item.tag="{ item }">
                                        <v-chip v-if="item.tag == 0" class="dark">
                                            <span style="font-size: 12px;">Not Set</span>
                                        </v-chip>

                                        <v-chip v-if="item.tag == 1" color="#3EBB80">
                                            <span style="font-size: 12px; color: #FFFFFF;">Existing Customer</span>

                                            <v-icon class="tags" style="color: #FFFFFF; cursor: pointer;" @click="item.tag = 0; removeTag(item);">mdi-close</v-icon>
                                        </v-chip>

                                        <v-chip v-if="item.tag == 2" color="#44468F">
                                            <span style="font-size: 12px; color: #FFFFFF;">Missed Call</span>

                                            <v-icon class="tags" style="color: #FFFFFF; cursor: pointer;" @click="item.tag = 0; removeTag(item);">mdi-close</v-icon>
                                        </v-chip>

                                        <v-chip v-if="item.tag == 3" color="#FFB443">
                                            <span style="font-size: 12px; color: #FFFFFF;">Opportunity</span>

                                            <v-icon class="tags" style="color: #FFFFFF; cursor: pointer;" @click="item.tag = 0; removeTag(item);">mdi-close</v-icon>
                                        </v-chip>

                                        <v-chip v-if="item.tag == 4" color="#2477F6">
                                            <span style="font-size: 12px; color: #FFFFFF;">Meeting Scheduled</span>

                                            <v-icon class="tags" style="color: #FFFFFF; cursor: pointer;" @click="item.tag = 0; removeTag(item);">mdi-close</v-icon>
                                        </v-chip>

                                        <v-chip v-if="item.tag == 5" color="#E53F71">
                                            <span style="font-size: 12px; color: #FFFFFF;">Became Customer</span>

                                            <v-icon class="tags" style="color: #FFFFFF; cursor: pointer;" @click="item.tag = 0; removeTag(item);">mdi-close</v-icon>
                                        </v-chip>

                                        <v-menu
                                                bottom
                                                right

                                                nudge-bottom='25'
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon color="green" v-bind="attrs" v-on="on" :ripple="false" small class="ml-1">mdi-plus</v-icon>
                                            </template>

                                            <v-list class="table-menu-actions p-2">
                                                <v-list-item class="hover:bg-gray-200">
                                                    <v-list-item-title><a href="javascript: void(0);"><span
                                                        class="table-menu-action-icon" style="color: #44468F;" @click="item.tag = 2; setTag(item, 2);">Missed Call</span></a>
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <v-list-item class="hover:bg-gray-200">
                                                    <v-list-item-title><a href="javascript: void(0);"><span
                                                        class="table-menu-action-icon" style="color: #FFB443;" @click="item.tag = 3; setTag(item, 3);">Opportunity</span></a>
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <v-list-item class="hover:bg-gray-200">
                                                    <v-list-item-title><a href="javascript: void(0);"><span
                                                        class="table-menu-action-icon" style="color: #2477F6;" @click="item.tag = 4; setTag(item, 4);">Meeting Scheduled</span></a>
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <v-list-item class="hover:bg-gray-200">
                                                    <v-list-item-title><a href="javascript: void(0);"><span
                                                        class="table-menu-action-icon" style="color: #E53F71;" @click="item.tag = 5; setTag(item, 5);">Became Customer</span></a>
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <v-list-item class="hover:bg-gray-200">
                                                    <v-list-item-title><a href="javascript: void(0);"><span
                                                        class="table-menu-action-icon" style="color: #3EBB80;" @click="item.tag = 1; setTag(item, 1);">Existing Customer</span></a>
                                                    </v-list-item-title>
                                                </v-list-item>
                                            </v-list>
                                        </v-menu>
                                    </template>

                                    <template v-slot:item.qualify_status="{ item }">
                                        <v-chip
                                                small
                                                color="gray lighten-5"
                                                text-color="gray lighten-1"
                                            
                                                v-if="item.qualify_status == 0"
                                        >
                                            Not Set
                                        </v-chip>

                                        <v-chip
                                                small
                                                color="green lighten-5"
                                                text-color="green lighten-1"
                                            
                                                v-if="item.qualify_status == 1"
                                        >
                                            Qualified
                                        </v-chip>

                                        <v-chip
                                                small
                                                color="red lighten-5"
                                                text-color="red lighten-1"
                                            
                                                v-if="item.qualify_status == -1"
                                        >
                                            Unqualified
                                        </v-chip>

                                        <v-chip
                                                small
                                                color="red darken-2"
                                                text-color="white"
                                            
                                                v-if="item.qualify_status == 2"
                                        >
                                            Spam
                                        </v-chip>

                                        <v-menu
                                                bottom
                                                right

                                                nudge-bottom='25'
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon color="green" v-bind="attrs" v-on="on" :ripple="false" small class="ml-1">mdi-plus</v-icon>
                                            </template>

                                            <v-list class="table-menu-actions">
                                                <v-list-item class="hover:bg-gray-200">
                                                    <v-list-item-title><a href="javascript: void(0);" @click="item.qualify_status = 1; setQualifyStatus(item, 1);"><span
                                                        class="table-menu-action-icon"><i
                                                        class="mdi mdi-check"></i></span> Set to Qualified</a>
                                                    </v-list-item-title>
                                                </v-list-item>
                                                <v-list-item class="hover:bg-gray-200">
                                                    <v-list-item-title><a href="javascript: void(0);" @click="item.qualify_status = -1; setQualifyStatus(item, -1);"><span
                                                        class="table-menu-action-icon"><i
                                                        class="mdi mdi-close"></i></span> Set to Unqualified</a>
                                                    </v-list-item-title>
                                                </v-list-item>
                                                <v-list-item class="hover:bg-gray-200">
                                                    <v-list-item-title><a href="javascript: void(0);" @click="item.qualify_status = 2; setQualifyStatus(item, 2);"><span
                                                        class="table-menu-action-icon"><i
                                                        class="mdi mdi-cancel"></i></span> Set to Spam</a>
                                                    </v-list-item-title>
                                                </v-list-item>
                                                <v-list-item class="hover:bg-gray-200">
                                                    <v-list-item-title><a href="javascript: void(0);" @click="item.qualify_status = 0; setQualifyStatus(item, 0);"><span
                                                        class="table-menu-action-icon"><i
                                                        class="mdi mdi-delete-outline"></i></span> Not Set</a>
                                                    </v-list-item-title>
                                                </v-list-item>
                                            </v-list>
                                        </v-menu>
                                    </template>
                                </v-data-table>
                            </div>
                        </div>
                    </v-card>
                </div>
            </template>
        
    </panel-navigation>
</template>

<script>

import { mapState } from 'vuex'
import $ from 'jquery';
import PanelNavigation from '@/components/PanelNavigation.vue'
import InboxThread from '@/views/panel/InboxThread.vue'
import CallModal from  "@/views/panel/Call/Call-Modal.vue"
import axios from 'axios'
import moment from 'moment'
import DialogBuyNumber from '@/components/dialogs/integrations/buyNumber.vue'

export default {
components: {
    CallModal,
    PanelNavigation,
    InboxThread,
    DialogBuyNumber
},
    computed: {
      ...mapState({
          me: (state) => state.me.me,
          profile: (state) => state.me.profile,
      }),
    },
data() {
    return {
        messages: [],
        loading: true,
        thisProc: false,
        show_picker: false,
        date_filter: null,
        search: "",

        tags_items: [{
            index: 0,
            text: 'Not Set'
        },{
            index: 1,
            text: 'Existing Customer'
        },{
            index: 2,
            text: 'Missed Call'
        },{
            index: 3,
            text: 'Opportunity'
        },{
            index: 4,
            text: 'Meeting Scheduled'
        },{
            index: 5,
            text: 'Became Customer'
        }],

        qualify_status_items: [{
            index: 0,
            text: 'Not Set'
        },{
            index: 1,
            text: 'Qualified'
        },{
            index: -1,
            text: 'Unqualified'
        },{
            index: 2,
            text: 'Spam'
        }],

        tag: "",
        qualify_status: "",

        headers: [
            { text: 'Timestamp', value: 'lead_creation_date' },
            { text: 'Customer Name', value: 'customer_name' },
            // { text: 'Charge Status', value: 'charge_status' },
            { text: 'Lead Number', value: 'customer_phone_number' },
            { text: 'Job Type', value: 'job_type' },
            { text: 'Postal Code', value: 'postal_code' },
            { text: 'Value', value: 'value' },
            { text: 'Tags', value: 'tag' },
            { text: 'Status', value: 'qualify_status' }
        ],

        exporting: false
    }
},

methods: {
    formatDate: function(date, format = "MM/DD/YYYY") {
        return moment(String(date)).format(format)
    },

    displayTimestamp(date) {
        let timezone = "America/New_York";

        return moment.utc(date).tz(timezone).format('ddd M/D YYYY h:mm:ss A');
    },

    displayDuration(seconds) {
        return date;
    },

    displayDuration(time) {
        var sec_num = time // don't forget the second param
        var hours   = Math.floor(sec_num / 3600);
        var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
        var seconds = sec_num - (hours * 3600) - (minutes * 60);

        if (hours   < 10) {hours   = "0"+hours;}
        if (minutes < 10) {minutes = "0"+minutes;}
        if (seconds < 10) {seconds = "0"+seconds;}
        return hours+':'+minutes+':'+seconds;
    },

    formatPhoneNumber(phoneNumberString) {
        const match = phoneNumberString
.replace(/\D+/g, '').replace(/^1/, '')
.match(/([^\d]*\d[^\d]*){1,10}$/)[0]
const part1 = match.length > 2 ? `(${match.substring(0,3)})` : match
const part2 = match.length > 3 ? ` ${match.substring(3, 6)}` : ''
const part3 = match.length > 6 ? `-${match.substring(6, 10)}` : ''    
return `${part1}${part2}${part3}`
    },

    playAudio(item) {
        if (document.getElementById('audio-element-wrapper-' + item.id).style.display == 'none') {
            let elements = document.getElementsByClassName('audio-element-wrapper');

            for (var i in elements) {
                try {
                    elements[i].style.display = 'none';
                }
                catch (e) {}
            }

            let elements2 = document.getElementsByClassName('audio-element');

            for (var i in elements) {
                try {
                    elements2[i].pause();
                    elements2[i].currentTime = 0;
                }
                catch (e) {}
            }

            let elements3 = document.getElementsByClassName('audio-element-icon');

            for (var i in elements) {
                try {
                    elements3[i].style.display = 'block';
                }
                catch (e) {}
            }

            document.getElementById('audio-element-wrapper-' + item.id).style.display = 'block';
            document.getElementById('audio-element-' + item.id).play();

            document.getElementById('audio-element-icon-' + item.id).style.display = 'none';

            
        }
        else {
            document.getElementById('audio-element-wrapper-' + item.id).style.display = 'none';
            document.getElementById('audio-element-' + item.id).pause();
            document.getElementById('audio-element-' + item.id).currentTime = 0;

            document.getElementById('audio-element-icon-' + item.id).style.display = 'block';
        }
    },

    showEditValue(item) {
        $('.lsa-show-value-' + item.id).hide();
        $('.lsa-edit-value-' + item.id).show();
        setTimeout(function() {
            $('.lsa-edit-value-' + item.id).focus();
        }, 20);
    },

    cancelEditValue(item) {
        $('.lsa-show-value-' + item.id).show();
        $('.lsa-edit-value-' + item.id).hide();
    },

    async editValue(item) {
        item.value = $('.lsa-edit-value-' + item.id + ' input').val();
        let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/edit-value-message`, {
            item: item
        }, {
            headers: {
                'Authorization': 'Bearer ' + this.$store.state.auth.jwt
            }
        });

        this.getMessages(true);

        $('.lsa-show-value').show();
        $('.lsa-edit-value').hide();
    },

    filterDate() {
        console.log(this.date_filter.length);
        if (!this.date_filter[1])
            return;

        this.show_picker = false;
        this.getMessages();
    },

    async getMessages(silent = false) {
        let self = this;

        if (!silent)
            this.loading = true;

        let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/get-messages`, {
            date_filter: this.date_filter,
            search: this.search,
            tag: this.tag,
            qualify_status: this.qualify_status
        }, {
            headers: {
                'Authorization': 'Bearer ' + this.$store.state.auth.jwt
            }
        })

        this.messages = response.data.messages;
        this.loading = false;
    },

    async setTag(item, tag) {
        let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/set-tag-message`, {
            message_id: item.id,
            tag: tag
        }, {
            headers: {
                'Authorization': 'Bearer ' + this.$store.state.auth.jwt
            }
        })

        this.getMessages(true);
    },

    async removeTag(item) {
        let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/remove-tag-message`, {
            message_id: item.id
        }, {
            headers: {
                'Authorization': 'Bearer ' + this.$store.state.auth.jwt
            }
        })

        this.getMessages(true);
    },

    async setQualifyStatus(item, qualify_status) {
        let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/set-qualify-status-message`, {
            message_id: item.id,
            qualify_status: qualify_status
        }, {
            headers: {
                'Authorization': 'Bearer ' + this.$store.state.auth.jwt
            }
        })

        this.getMessages(true);
    },

    downloadCsv() {
        this.exporting = true;

        let self = this;

        let csv = 'Timestamp, Customer Name, Lead Number, Job Type, Postal Code, Tag, Status\n';
        this.messages.forEach((row) => {

            let tag = 'Not Set';

            for (var i in this.tags_items) {
                if (this.tags_items[i].index == row.tag)
                    tag = this.tags_items[i].text
            }

            let status = 'Not Set';

            for (var i in this.qualify_status_items) {
                if (this.qualify_status_items[i].index == row.qualify_status)
                    status = this.qualify_status_items[i].text
            }

            let csv_data = [
                '"' + self.displayTimestamp(row.lead_creation_date) + '"',
                '"' + row.customer_name + '"',
                row.customer_phone_number,
                '"' + row.job_type.replace(/\_/g, " ").toLowerCase().replace(/\b[a-z]/g, function(letter) { return letter.toUpperCase(); }) + '"',
                '"' + row.postal_code + '"',
                tag,
                status
            ]

            csv += csv_data.join(',');
            csv += "\n";
        });
    
        const anchor = document.createElement('a');
        anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
        anchor.target = '_blank';
        anchor.download = 'calls-' + this.date_filter.join("-") + ".csv";
        anchor.click();

        this.exporting = false;
    },
},

destroyed() {
    clearTimeout(this.thisProc);
    this.thisProc = null;
},

created() {
    let self = this
    self.getMessages();

    // this.thisProc = setInterval(function() {
    //     self.getMessages(true);
    // }, 5000);
}
}
</script>


<style scoped>
.custom-text-field .v-input__control input {
border-color: white !important;
}

.v-text-field--outlined fieldset {
border: 1px solid red;
}
.header-inputs {
border-color: white !important;
}

.theme--light.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state) > .v-input__control > .v-input__slot fieldset {
color: rgba(0, 0, 0, 0.38);
border-color: white !important;
}

.v-text-field--outlined fieldset {
border: 1px solid white !important;
}

.status-chip {
font-weight: bold;
text-transform: uppercase;
}

.status-Qualified {
color: green !important;
border-color: green !important;

}

.status-inQualified {
color: red;
border-color: red;
}

.custom-badge {
background-color: rgba(0, 230, 130, 0.1) !important;
color: #09ad95 !important;
}

.tags {
color: #e0e0e0;
font-size: small;
padding-left: 5px;

}

.icon-container {
display: flex;
align-items: center;
justify-content: center;
width: 48px;
height: 48px;
border-radius: 50%;
border: 2px solid #ccc;
cursor: pointer;
}

.icon {
font-size: 24px;
}
</style>